export const INITIAL_STATE = {
    themeName: '',
    smsMessage: '',
    emailMessage: '',
    emailSubject: '',
    backgroundImageUrl: '',
    thumbnailImageUrl: '',
    frontImageUrl: '',
    backImageUrl: '',
    mobileImageUrl: '',
    loading: false,
    error: '',
    success: false,
    validated: false,
    categories: [],
    selectedCategoryId: '',
};

export const SUCCESS_MESSAGE = 'VOUCHER_THEME_ADDED_SUCCESSFULLY';

export const TOAST_MESSAGES = {
    success: 'Voucher theme created successfully!',
    error: 'Failed to create voucher theme. Please try again.',
    categoryError: 'Failed to fetch categories',
};

export const VALIDATION_ERROR_MESSAGES = {
    themeName: 'Please provide a theme name.',
    frontImageUrl: 'Front image URL is required',
    backImageUrl: 'Back image URL is required',
    mobileImageUrl: 'Mobile image URL is required',
    emailSubject: 'Email subject is required',
    emailMessage: 'Email message is required',
    smsMessage: 'SMS message is required',
};

export const VOUCHER_THEME_FORM_FIELDS = [
    {
        name: 'themeName',
        label: 'Theme Name',
        type: 'text',
        placeholder: 'Enter theme name',
        required: true,
        validationMessage: 'Please provide a theme name.',
    },
    {
        name: 'frontImageUrl',
        label: 'Front Image URL',
        type: 'text',
        placeholder: 'Enter front image URL',
        required: true,
        validationMessage: 'Front image URL is required',
    },
    {
        name: 'backImageUrl',
        label: 'Back Image URL',
        type: 'text',
        placeholder: 'Enter back image URL',
        required: true,
        validationMessage: 'Back image URL is required',
    },
    {
        name: 'mobileImageUrl',
        label: 'Mobile Image URL',
        type: 'text',
        placeholder: 'Enter mobile image URL',
        required: true,
        validationMessage: 'Mobile image URL is required',
    },
    {
        name: 'thumbnailImageUrl',
        label: 'Thumbnail Image URL',
        type: 'text',
        placeholder: 'Enter thumbnail image URL',
        required: false,
    },
    {
        name: 'backgroundImageUrl',
        label: 'Background Image URL',
        type: 'text',
        placeholder: 'Enter background image URL',
        required: false,
    },
    {
        name: 'emailSubject',
        label: 'Email Subject',
        type: 'text',
        placeholder: 'Enter email subject',
        required: true,
        validationMessage: 'Email subject is required',
    },
    {
        name: 'emailMessage',
        label: 'Email Message',
        type: 'textarea',
        placeholder: 'Enter email message',
        required: true,
        validationMessage: 'Email message is required',
    },
    {
        name: 'smsMessage',
        label: 'SMS Message',
        type: 'textarea',
        placeholder: 'Enter SMS message',
        required: true,
        validationMessage: 'SMS message is required',
    },
];